'use strict';

var ReactRelayLoggingContext = require('./../ReactRelayLoggingContext');
var _require = require('react'),
  useContext = _require.useContext;
function useRelayLoggingContext() {
  return useContext(ReactRelayLoggingContext);
}
module.exports = useRelayLoggingContext;